const { Component, Fragment } = wp.element;

export class ResultItem extends Component {

  render() {
    let html = '';
    if ( this.props.items.length ) {
      for ( let item of this.props.items ) {
        html += item.content_rendered;
      }
    }
    return html ? (
      <ul className="list-unstyled small-news-thumb" dangerouslySetInnerHTML={{__html: html}}></ul>
     ) : (
      <p className='text-muted'>検索結果が見つかりませんでした。</p>
    ) ;
  }
}
